import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Random24dxadk52mliy as Random,
  takeUpperBits23varjnd7v1uz as takeUpperBits,
} from './Random.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkInvariants($this) {
  // Inline function 'kotlin.require' call
  if (!!(($this.fp_1 | $this.gp_1 | $this.hp_1 | $this.ip_1 | $this.jp_1) === 0)) {
    var message = 'Initial state must have at least one non-zero element.';
    throw IllegalArgumentException().o2(toString(message));
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.mp_1 = 0n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var XorWowRandomClass;
function XorWowRandom() {
  if (XorWowRandomClass === VOID) {
    class $ extends Random() {
      constructor(x, y, z, w, v, addend) {
        return new.target.np(x, y, z, w, v, addend);
      }
      static np(x, y, z, w, v, addend) {
        var $this = this.vo();
        $this.fp_1 = x;
        $this.gp_1 = y;
        $this.hp_1 = z;
        $this.ip_1 = w;
        $this.jp_1 = v;
        $this.kp_1 = addend;
        checkInvariants($this);
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < 64)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            $this.vk();
          }
           while (inductionVariable < 64);
        return $this;
      }
      static lp(seed1, seed2) {
        return this.np(seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ (seed2 >>> 4 | 0));
      }
      vk() {
        var t = this.fp_1;
        t = t ^ (t >>> 2 | 0);
        this.fp_1 = this.gp_1;
        this.gp_1 = this.hp_1;
        this.hp_1 = this.ip_1;
        var v0 = this.jp_1;
        this.ip_1 = v0;
        t = t ^ t << 1 ^ v0 ^ v0 << 4;
        this.jp_1 = t;
        this.kp_1 = this.kp_1 + 362437 | 0;
        return t + this.kp_1 | 0;
      }
      wo(bitCount) {
        return takeUpperBits(this.vk(), bitCount);
      }
    }
    initMetadataForClass($, 'XorWowRandom');
    XorWowRandomClass = $;
  }
  return XorWowRandomClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  XorWowRandom as XorWowRandom4dcuf9lla8j1,
};
//endregion

//# sourceMappingURL=XorWowRandom.mjs.map
